import React, { ReactNode } from 'react';

import { TabItem } from 'components/DesignSystem/Tabs';
import TableTab from 'components/widgets/ActivityCompletionPlan/components/TableTab/TableTab';
import classes from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivityTabs/simulatedActivitiesTabs.module.scss';

export type TabKeys = 'wbs' | 'activities';

export const generateTabs = (): TabItem[] => {
    return [
        {
            value: 'wbs',
            label: 'WBS Level Changes',
        },
        {
            value: 'activities',
            label: 'Activities Level Changes',
        },
    ];
};
